module.exports = __webpack_public_path__ + "img/12.be6b62be.jpg";